// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tZtuM{display:-webkit-box;display:flex;margin:0;width:100%}.tZtuM+.tZtuM{margin-top:1rem}.gS4lt{align-self:center;color:#747c7f;margin:0 23px 0 0;width:25px}.ARZG9{height:24px}@media screen and (min-width:768px){.ARZG9{margin-right:20px}}.OyRej{height:25px}@media screen and (min-width:768px){.OyRej{margin-right:21px}}.Leuh0{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-flex:1;flex:1 1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `tZtuM`,
	"icon": `gS4lt`,
	"icon_date": `ARZG9`,
	"icon_time": `OyRej`,
	"content": `Leuh0`
};
module.exports = ___CSS_LOADER_EXPORT___;
